import React, { useState, useEffect } from "react";
import IntroScreen from "./components/IntroScreen";
import TopNav from "./components/TopNav";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Contact from "./pages/Contact";
import ProductsShowcase from "./pages/ProductsShowcase";
import DivisionShowcase from "./pages/DivisionShowcase";
import Divisions from "./pages/Divisions";
import Footer from "./components/Footer";
import "./App.css";
import Employment from "./pages/Employment";

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [currentPage, setCurrentPage] = useState("home");
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [navVisible, setNavVisible] = useState(true);

  const handleIntroFinish = () => {
    setShowIntro(false);
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [currentPage, selectedProductId, selectedDivisionId]);

  const handleNavigate = (page, id = null) => {
    setCurrentPage(page);
    if (page === "productShowcase") {
      setSelectedProductId(id);
    } else if (page === "divisionShowcase") {
      setSelectedDivisionId(id);
    }
  };

  const renderPage = () => {
    switch (currentPage) {
      case "divisions":
        return <Divisions onNavigate={handleNavigate} />;
      case "products":
        return <Products onNavigate={handleNavigate} />;
      case "about":
        return <About />;
      case "privacy":
        return <Privacy />;
      case "terms":
        return <Terms />;
      case "contact":
        return <Contact />;
      case "employment":
        return <Employment onNavigate={handleNavigate} />;
      case "productShowcase":
        return (
          <ProductsShowcase
            productId={selectedProductId}
            onNavigate={handleNavigate}
          />
        );
      case "divisionShowcase":
        return (
          <DivisionShowcase
            divisionId={selectedDivisionId}
            onNavigate={handleNavigate}
          />
        );
      case "home":
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="App">
      {showIntro ? (
        <IntroScreen onFinish={handleIntroFinish} />
      ) : (
        <>
          <TopNav
            currentPage={currentPage}
            onNavigate={handleNavigate}
            onNavVisibilityChange={setNavVisible}
          />
          {renderPage()}
          <Footer onNavigate={handleNavigate} />
        </>
      )}
    </div>
  );
}

export default App;
